





























import Vue from 'vue';
import SpielerComp from "../../components/raid/SpielerComp.vue";
import _raids from '../../services/endpoints/raids';
import SpielerEinladenComp from "../../components/raid/SpielerEinladenComp.vue";
import BuildFilterButtonsComp from "../../components/raid/BuildFilterButtonsComp.vue";
import { userRaid } from 'models/Types';

export default Vue.extend({
	name: "SpielerlistePage",
	components: {BuildFilterButtonsComp, SpielerEinladenComp, SpielerComp},
	data: () => ({
		filter: '',
		users: [] as any[],
	}),
	computed: {
		raid: function(): userRaid {
			return this.$vStore.getters.raid;
		},
		showSpielerEinladen: function(): boolean {
			return this.$vStore.getters.raidRole > 1;
		}
	},
	methods: {
		kick: async function(user: any): Promise<void> {
			this.users = await _raids.kickPlayer(this.raid.id, user.id);
		},
		setFilter: function(filter: any): void {
			this.filter = filter;
		}
	},
	created: async function(): Promise<void> {
		if (this.raid) {
			this.users = await _raids.listPlayers(this.raid.id);
		}
	}
})
